// Libs
import classNames from 'classnames/bind';
import { Box, CircularProgress } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './Loading.module.scss';

type LoadingProps = {
  loading?: boolean;
  overlay?: boolean;
};

const cx = classNames.bind(styles);

const Loading = (props: LoadingProps) => {
  //#region Destructuring Props
  const { loading = true, overlay = false } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  if (!loading) return null;

  return (
    <Box className={cx('loadingContainer', overlay ? 'overlay' : 'noOverlay')}>
      <CircularProgress />
    </Box>
  );
};

export default Loading;
